import { render, staticRenderFns } from "./SendPassword.vue?vue&type=template&id=9f790d70&"
import script from "./SendPassword.vue?vue&type=script&lang=js&"
export * from "./SendPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports